import React, { useEffect, useMemo, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { Edit } from '@components/icons'
import ButtonIcon from '../ButtonIcon/ButtonIcon'
import FormBlurSaveInput from '../FormBlurSaveInput/FormBlurSaveInput'
import styles from './FormRitardoInput.module.sass'


interface Props {
  level: 'generic' | 'parent' | 'child'
  objectId: number // Id dell'elemento a seconda del level, sarà un fornitore per generic, tecnicaPadre per parent e tecnica per child
  rifValue?: string // valore di riferimento del padre
  value?: string
  setValue?: (v: string) => void
  className?: string
}

const FormRitardoInput = (props: Props) => {

  const { 
    level,
    objectId,
    rifValue,
    value,
    setValue,
    className = '',
  } = props

  const t = useTrans()
  
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState(undefined)
  const [localValue, setLocalValue] = useState(value)
  const [lastSavedValue, setLastSavedValue] = useState(value)

  useEffect(() => {
    // se value cambia rispetto a localValue, aggiorno localValue e salvo (es. cambiamento da azione multipla che non attiva il save al blur)
    if (value !== localValue){
      setLocalValue(value)
    }
  }, [value])

  const save = (v: string | null) => {
    setStatus(undefined)
    if (v !== lastSavedValue) {
      if (v && !parseInt(v)) {
        setStatus('error')
      }
      else { 
        setLoading(true)

        // TODO - salvataggio con API (simulato con setTimeout)
        // A disposizione si hanno level e objectId per identificare cosa va salvato
        setTimeout(() => {
          const statusRicevuto = 'success'
          setStatus(statusRicevuto)
          setLoading(false)

          // Se è stato salvato con successo, dopo 3 secondi resetto lo stato
          if (statusRicevuto === 'success') {
            setValue(v)
            setLastSavedValue(v)
            setTimeout(() => {
              setStatus(undefined)
            }, 2000)
          }
        }, 500)
      }
    }
  }

  const custom = useMemo(() => (level === 'generic') || (typeof value !== 'undefined'), [value])

  const handleToggle = () => {
    const nextValue = custom ? undefined : rifValue
    setLocalValue(nextValue)
    save(nextValue)
  }

  return (
    <div className={cn(styles.root, custom ? styles[`root--custom`] : '', className)}>
      <FormBlurSaveInput 
        loading={loading}
        status={status}
        disabled={!custom}
        value={custom ? localValue : rifValue}
        variant={!parseInt(custom ? localValue : rifValue) ? 'warning' : 'default'}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={(e) => save(e.target.value)}
      />
      {(level !== 'generic') && (
        <ButtonIcon
          icon={<Edit />} 
          variant="ghost"
          size="lg"
          colorVariant={custom ? 'accent' : 'black'}
          onClick={handleToggle} 
          ariaLabel={t(custom ? "Rimuovi personalizzazione" : "Personalizza")} 
        />
      )}
    </div>
  )
}

export default FormRitardoInput
